function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M246 0C110 0 0 112 0 249c0 138 110 250 246 250 135 0 246-112 246-250C492 112 381 0 246 0zm0 421c-21 0-38-17-38-39 0-21 17-38 38-38s38 17 38 38c0 22-17 39-38 39zm38-145c0 21-17 39-38 39s-38-18-38-39V116c0-21 17-38 38-38s38 17 38 38z"
})));